// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Edit_wrapper__2DDuM"};